import gql from 'graphql-tag';

const QUERY_USERS = gql`
  query users($filter: ListUsersFilterInput, $limit: Int) {
    users (filter: $filter, limit: $limit) {
      isSuccess
      message
      users {
        id
        firstName
        lastName
        email
        roles
        createdAt
        deletedAt
        createdBy {
          id 
          firstName
          lastName
        }
      }
    }
  }
`;

export default QUERY_USERS;
